import { Script } from './Script';
import { NavigateConfig } from './navigate-config';
import { WaitingOfferDialogData } from '../../shared/components/dialogs/waiting-offer-dialog/waiting-offer-dialog.component';
import { Dictionary } from './dictionary';
import { PredefinedValues } from '../services/impl/section-services/predefined-values/predefined-values.service';
import { LoadingOffersDialogData } from '../../shared/components/dialogs/loading-offer-dialog/loading-offers-dialog.component';
import {StepKey} from '../enums/step-key.enum';

export class UiConfig {

  // dictionaries keys
  static VEHICLE_TYPE = 'VEHICLE_TYPE';
  static PARKING_PLACE = 'COMMUNICATION_PARKING_PLACE';
  static PARTY_TYPE_CODE: string = 'PARTY_TYPE_CODE';
  static YOUNGEST_DRIVER_AGE = 'YOUNGEST_DRIVER_AGE';
  static AVG_MILEAGE_PER_YEAR: string = 'COMMUNICATION_AVERAGE_MILEAGE';
  static DRIVING_LICENSE_ISSUE_YEAR = 'DRIVING_LICENSE_ISSUE_YEAR';
  static VEHICLE_CONDITION = 'COMMUNICATION_VEHICLE_CONDITION';
  static IS_VALID_CAR_INSPECTION = 'IS_VALID_CAR_INSPECTION';
  static USABLE_VEHICLE_BEYOND_BORDER: string = 'USABLE_VEHICLE_BEYOND_BORDER';
  static USAGE_TYPE: string = 'COMMUNICATION_USAGE_TYPE';
  static ABROAD_IMPORTED: string = 'COMMUNICATION_ABROAD_IMPORTED';
  static MATRIMONIAL_STATUS: string = 'COMMUNICATION_MATRIMONIAL_STATUS';
  static PROFESSIONS: string = 'COMMUNICATION_PROFESSIONS';
  static ABROAD_USAGE_TIME = 'COMMUNICATION_ABROAD_USAGE_TIME';
  static COUNTRIES_REGISTRATION = 'COMMUNICATION_COUNTRIES_REGISTRATION';
  static KEYS_AMOUNT = 'COMMUNICATION_KEYS_AMOUNT';
  static LEECHED_KEYS_AMOUNT = 'COMMUNICATION_LEECHED_KEYS_AMOUNT';
  static VEHICLE_COUNTRY_OF_ORIGIN = 'COMMUNICATION_VEHICLE_COUNTRY_OF_ORIGIN';

  // additional options
  scripts: Script[];
  resources: Resources;
  sessionEndpoint: string;
  resourcesEndpoint: string;
  dictionaries: Dictionaries;
  calculationEndpoint: string;
  calculationOptionalEmailEndpoint: string; // mail sent from offers/payment step (send calculation button)
  cessionEndpoints: [{ companyCode: string, url: string }];
  notificationEndpoint: string;
  navigateConfig: NavigateConfig;
  additionalNavigateConfig: any;
  sendNotificationEndpoint: string;
  submitOrderPolicyEndpoint: string;
  offerPackageNameEndpoint: string;
  maxWaitForOffersOnOfferScreen: number;
  wsOpenedTime: number;
  partnerNameExpirationDays: number;
  portalPartnerDataExpirationDays: number;
  vehicleServiceEndpoint: string;
  vehiclesServiceEndpoint: string;
  metricsEndpoint: string;
  defaultLanguage: string;
  waitingOfferDialogConfig: WaitingOfferDialogData;
  loadingOfferDialogConfig: LoadingOffersDialogData;
  unsupportedDataDialogConfig: any;
  noOffersFoundDialogConfig: any;
  entryInformationDialogConfig: any;
  offerUpdateDialogConfig: any;
  offerRecalculationDialogConfig: any;
  headerConfig: any;
  mainContentConfig: any;
  citiesDictionaryEndpoint: string;
  streetsDictionaryEndpoint: string;
  bankNameDictionaryEndpoint: string;
  aztecHandlingEndpoint: string;
  prepareRegistrationEndpoint: string;
  offerModifyEndpoint: string;
  postalCodeValidationEndpoint: string;
  offerRecommendationsEndpoint: string;
  draftOfferEndpoint: string;

  agreementsConfig: AgreementsConfig[];
  predefinedValues: PredefinedValues;
  filtersEnabled?: boolean;
  offerModificationsEnabled: boolean;
  retrieveIPFromExternalService?: boolean;
  bannersConfig?: BannersConfig;
  pzuBannerVisible?: boolean;

  constructor() {
    this.dictionaries = {};
    this.resources = {};
  }
}

export interface Dictionaries {
  [key: string]: Dictionary;
}

export interface Resources {
  [key: string]: string;
}

export interface AgreementsConfig {
  stepsAllowed: StepKey;
  agreementCode: string;
}

export enum AgreementDestination {
  FIRST_STEP = 'FIRST_STEP',
  THIRD_STEP = 'THIRD_STEP'
}

export interface BannerConfig {
  visible: boolean;
  bannerPath?: string;
}

export interface BannersConfig {
  [stepKey: string]: {
    web?: BannerConfig,
    mobile?: BannerConfig
  }
}
